import * as React from 'react';
import {useSelector} from "react-redux";
import Typography from "@mui/material/Typography";
import {selectRequestState} from "../../../store/request/stateSlice";

const formatDateTime = (dateTimeString) => {
    const date = new Date(dateTimeString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const strHours = String(hours).padStart(2, '0');

    return `${day}/${month}/${year} ${strHours}:${minutes} ${ampm}`;
};

function DetailService() {

    const {item} = useSelector(selectRequestState);

    return <>
        <Typography color="white">Desde:</Typography>
        <Typography color="white" variant="h6" fontWeight="bold">{item.org.address}</Typography>

        <Typography color="white" marginTop={2}>Hasta:</Typography>
        <Typography color="white" variant="h6" fontWeight="bold">{item.dst.address}</Typography>

        <Typography color="white" marginTop={2}>Viaje:</Typography>
        <Typography color="white" variant="h6" fontWeight="bold">
            {item.type_request == 'no_return' ? 'Solo ida' : 'Ida y vuelta'}
        </Typography>

        <Typography color="white" marginTop={2}>Fecha:</Typography>
        <Typography color="white" variant="h5" fontWeight="bold">
            {formatDateTime(item.date_start)}
        </Typography>

        {item.type_request != 'no_return' && <>
            <Typography color="white" marginTop={2}>Fecha de retorno:</Typography>
            <Typography color="white" variant="h5" fontWeight="bold">
                {formatDateTime(item.date_return)}
            </Typography>
        </>}

        <Typography color="white" marginTop={2}>Pasajeros:</Typography>
        <Typography color="white" variant="h5" fontWeight="bold">
            {item.capacity_1}
        </Typography>

        <Typography color="white" marginTop={2}>Producto:</Typography>
        <Typography color="white" variant="h5" fontWeight="bold">
            {item.product?.name}
        </Typography>
    </>;
}

export default DetailService;